import { getLabeledBooleanFilterOperators } from "../getLabeledBooleanFilterOperators";

export const lostModeFilterOperators = getLabeledBooleanFilterOperators(["Found", "Lost"], "found");

export const lowBatteryFilterOperators = getLabeledBooleanFilterOperators(["OK", "Low"], false);
